<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { doubleConfirmation } from "./utils/ErrorMessages";
import db from "./utils/db";

export default {
  data() {
    return {};
  },
  created() {
    db.deleteIndexedDB("loadCreation");
    db.createDb({ dbName: "quoteBook" });
    this.$onNewVersion(() => {
      this.showAlert();
    });
  },
  watch: {
    "$route.path": {
      async handler() {
        if (this.$route.name && this.$route.name.toLowerCase() === "myloads") {
          this.$store.commit("load/resetChosenload");
        }
        // await this.getMagayaToken();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async getMagayaToken() {
      const queryParams = Object.keys(this.$route.query);
      if (queryParams.length) {
        await this.$store.dispatch("login/signInMagaya", this.$route.query);
      }
    },
    reloadApp() {
      window.location.reload(true);
    },
    async showAlert() {
      // eslint-disable-next-line max-len
      await doubleConfirmation({ text: 'We’ve got a fresh new version ready for you. To make sure everything runs perfectly, we’ve signed you out just this once. Log back in and enjoy the latest features and improvements!' });
      this.reloadApp();
    }
  },
};
</script>

<style lang="scss">
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color-primary-company;
  @include font-standart-text;
}
@media (max-width: 992px) {
  body::-webkit-scrollbar {
    display: none;
  }
}
.custom-tooltip {
  border: none !important;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  border-radius: 8px !important;
  padding: 12px;
}
.popper__arrow {
  border-right-color : white !important;
}

</style>
